import { request, Response } from '../utils';
import { Session } from '../types';

export const updateGraphPublicAccess = (body: {
  session: Session;
  graphID: string;
  isPublic: boolean;
}): Response<null> => request('update-graph-public-access', body);
